var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLeaderboardImg3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.00033 1.1665C5.47199 1.1665 4.22949 2.409 4.22949 3.93734C4.22949 5.4365 5.40199 6.64984 6.93033 6.70234C6.97699 6.6965 7.02366 6.6965 7.05866 6.70234C7.07033 6.70234 7.07616 6.70234 7.08783 6.70234C7.09366 6.70234 7.09366 6.70234 7.09949 6.70234C8.59283 6.64984 9.76533 5.4365 9.77116 3.93734C9.77116 2.409 8.52866 1.1665 7.00033 1.1665Z",
    fill: "#B1B1B1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.96356 8.25418C8.33605 7.16918 5.68189 7.16918 4.04272 8.25418C3.30189 8.75001 2.89355 9.42085 2.89355 10.1383C2.89355 10.8558 3.30189 11.5208 4.03689 12.0108C4.85355 12.5592 5.92689 12.8333 7.00022 12.8333C8.07355 12.8333 9.14689 12.5592 9.96356 12.0108C10.6986 11.515 11.1069 10.85 11.1069 10.1267C11.1011 9.40918 10.6986 8.74418 9.96356 8.25418Z",
    fill: "#B1B1B1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeaderboardImg3);
export default __webpack_public_path__ + "static/media/leaderboard_img3.a97a59bce369821bb63f6c63ebd6a587.svg";
export { ForwardRef as ReactComponent };